import { FUNCTIONALITY } from "@/components/catalogForcast/constants";
import CatalogForecastDashboard from "@/components/catalogForcast/pages/CatalogForecastDashboard";
import CatalogForecastMarketFromDashboard from "@/components/catalogForcast/pages/CatalogForecastMarketFromDashboard";
import CatalogForecastMarketFromMenu from "@/components/catalogForcast/pages/CatalogForecastMarketFromMenu";
import AccessUser from "@/plugins/AccessUser";
import { PROFILES } from "@/plugins/constant";
import { APPLICATION } from "@/components/admin/brand/constant";

export const ROUTES = Object.freeze({
    BASE: "/admin/catalog_forecast"
});

export const router = [
    {
        path: ROUTES.BASE + "/dashboard",
        component: CatalogForecastDashboard,
        name: "CatalogForecastDashboard",
        meta: {
            requiresAuth: true,
            title: "Catalog forecast - Dashboard",
            action: AccessUser.ACTION.UPDATE,
            apps: [APPLICATION.CATALOG_FORECAST_ID],
            profiles: [PROFILES.FORECAST_MANAGER, PROFILES.COORDINATOR],
            functionality: [FUNCTIONALITY, AccessUser.SUPPER_ADMIN]
        }
    },
    {
        path: ROUTES.BASE + "/market/:id",
        component: CatalogForecastMarketFromDashboard,
        name: "CatalogForecastMarketFromDashboard",
        meta: {
            requiresAuth: true,
            title: "Catalog forecast - Market",
            action: AccessUser.ACTION.READ,
            apps: [APPLICATION.CATALOG_FORECAST_ID],
            profiles: [PROFILES.FORECAST_MANAGER, PROFILES.COORDINATOR, PROFILES.ZONES_SUPERVISOR, PROFILES.ZONE_FORECASTER],
            functionality: [FUNCTIONALITY, AccessUser.SUPPER_ADMIN]
        }
    },
    {
        path: ROUTES.BASE + "/market",
        component: CatalogForecastMarketFromMenu,
        name: "CatalogForecastMarketFromMenu",
        meta: {
            requiresAuth: true,
            title: "Catalog forecast - Market",
            action: AccessUser.ACTION.READ,
            apps: [APPLICATION.CATALOG_FORECAST_ID],
            profiles: [PROFILES.FORECAST_MANAGER, PROFILES.COORDINATOR, PROFILES.ZONES_SUPERVISOR, PROFILES.ZONE_FORECASTER],
            functionality: [FUNCTIONALITY, AccessUser.SUPPER_ADMIN]
        }
    }
];



// WEBPACK FOOTER //
// ./src/components/catalogForcast/router.js